import { useEffect, useRef } from 'react';
const DEFAULT_DROPKIT_CSS_PATH = './dropkit/dropkit.css';
/**
 * Get the path to the Dropkit CSS file so we can link to it from the shadow DOM
 */
const getDropkitCSSPath = () => {
    const cssPath = document.querySelector('link[rel="stylesheet"][href*="dropkit.css"]');
    return cssPath ? cssPath.href : DEFAULT_DROPKIT_CSS_PATH;
};
/**
 * Shadow DOM's live in their on little world, so they don't "see" the parent pages CSS linked stylesheets.
 * Therefore, we need to inject the styles into the shadow DOM - like this...
 * @param cssUrl
 * @returns
 */
export const useShadowStyles = (cssUrl = '') => {
    const ref = useRef(null);
    useEffect(() => {
        if (!ref.current)
            return;
        const shadowRoot = ref.current.getRootNode();
        if (!shadowRoot)
            return;
        const newCssUrl = cssUrl || getDropkitCSSPath();
        // Inject styles dynamically from the built CSS file
        if (!shadowRoot.querySelector('link[data-injected]')) {
            const link = document.createElement('link');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('href', newCssUrl);
            link.setAttribute('data-injected', 'true'); // Prevent multiple injections
            shadowRoot.appendChild(link);
        }
    }, [cssUrl]);
    return ref;
};
